import { Injectable } from '@angular/core';
import { BaseFacadeService } from '../base-state-service/base-facade.service';
import { OverallStateService } from './overall-state.service';
import { OverallStoreEnum, OverallStoreState } from '../models/overall-store';
import { UploadfileService } from './uploadfile.service';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class OverallFacadeService extends BaseFacadeService<OverallStateService, OverallStoreState> {

    constructor(private overallStateService: OverallStateService, private uploadFileService: UploadfileService,) {
        super(overallStateService);
    }

    domainInfoApi(): Observable<any> {
        return this.uploadFileService.domainInfoAPICall().pipe(
           tap(response => 
           { this.updateSpecificState(response, OverallStoreEnum.allData) } ));
    }
}
